<template>
  <div class="check-in__terms">
    <p class="signature-agreement">
      {{ defaultLegalese }} {{ storeLegalese }}
    </p>

    <div class="signature-wrapper" ref="sigwrapper">
      <canvas class="signature" ref="canvas"></canvas>
    </div>

    <v-btn
      class="mt-3 ml-0"
      :disabled="formInvalid"
      color="primary"
      :loading="loading"
      @click="handleTermsSubmit"
    >Check in</v-btn>

  </div>
</template>

<script>
import SignaturePad from 'signature_pad/dist/signature_pad'
import { mapActions, mapState, mapGetters } from 'vuex'
import { get } from 'lodash'

export default {
  props: {
    buy: Object,
    working: Boolean,
    formErrors: Object,
    driverLicense: Object
  },
  data () {
    return {
      loading: false,
      signaturePad: '',
      signaturePresent: false,
      success: false,
      workingText: 'Checking in...'
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.mountSignaturePad()
    })
  },
  computed: {
    ...mapState([
      'winmarkStore',
      'checkinKey',
      'raiStore',
      'defaultLegalese'
    ]),
    ...mapGetters([
      'buyCheckinKey'
    ]),
    storeLegalese () {
      return this.raiStore.buy_config.legalese || ''
    },
    formInvalid () {
      return !this.signaturePresent
    },
    formValid () {
      return !this.formInvalid && this.signaturePresent
    },
    customerFirstName () {
      return this.buy.customer.full_name.trim().split(' ')[0]
    },
    customerLastName () {
      let split = this.buy.customer.full_name.trim().split(' ')
      return split.slice(1).join(' ')
    },
    customerLoyalty () {
      return !!this.buy.customer.loyalty
    },
    customer () {
      return this.buy.customer
    },
    buyPayload () {
      return {
        key: this.$store.state.checkinKey,
        buy: {
          signature: this.buy.signature,
          signin_full_name: `${this.customerFirstName} ${this.customerLastName}`,
          signin_email: this.buy.customer.email,
          signin_phone_number: this.customer.phone_number,
          signin_address_1: this.buy.signin_address_1,
          signin_address_2: this.buy.signin_address_2,
          signin_city: this.buy.signin_city,
          signin_state: this.buy.signin_state,
          signin_postal_code: this.buy.signin_postal_code,
          signin_id_number: this.driverLicense.number,
          signin_id_expire_date: this.driverLicense.expire_date
          // signin_birth_date: ,
          // signin_id_type: ,
        },
        customer: {
          id: this.buy.customer.id,
          first_name: this.customerFirstName,
          last_name: this.customerLastName,
          phone_number: this.customer.phone_number,
          email: this.buy.customer.email,
          loyalty: this.customerLoyalty
        },
        driver_license: {
          full_name: this.customer.full_name,
          number: this.driverLicense.number,
          state: this.driverLicense.state,
          expire_date: this.driverLicense.expire_date
        },
        store: {
          id: this.buy.store_id || this.raiStore.id
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'createBuy',
      'updateBuy'
    ]),
    mountSignaturePad () {
      let canvas = this.$refs.canvas
      let wrapper = this.$refs.sigwrapper
      canvas.width = wrapper.clientWidth
      canvas.height = wrapper.clientHeight
      this.signaturePad = new SignaturePad(canvas, {
        onEnd: this.handleSignatureOnEnd
      })
      let context = canvas.getContext('2d')
      context.fillStyle = '#FFFFFF'
      context.fillRect(0, 0, canvas.width, canvas.height)
    },
    getSignature () {
      let sig
      if (!this.signaturePad.isEmpty()) {
        sig = this.signaturePad.toDataURL()
      }
      return sig
    },
    handleSignatureOnEnd () {
      if (this.signaturePad && !this.signaturePad.isEmpty()) {
        this.signaturePresent = true
        this.$emit('input-signature', this.getSignature())
      }
    },
    handleTermsSubmit () {
      if (this.formValid) {
        window.scrollTo(0, 0)
        this.loading = true
        let action
        if (this.checkinKey) { action = this.updateBuy }
        if (!this.checkinKey) { action = this.createBuy }
        if (action) {
          action(this.buyPayload)
            .then((response) => {
              if (!get(this.$route.params, 'checkin_key', false)) {
                this.$router.push({ path: `/b/${this.buyCheckinKey}` })
              }
            })
            .catch((error) => {
              console.log(error)
            })
            .then(() => { this.loading = false })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .check-in__terms {
    // position: absolute;
    // width: 100%;
    // margin-top: 1em;
    // padding-bottom: 3em;

    .signature-agreement {
      padding:    0 0.2em;
    }

    .signature-wrapper {
      width:      100%;
      height:     100%;
      background: white;
      border:     1px solid #ddd;
      position:   relative;

      &::before {
        content:    'Signature';
        position:   absolute;
        right:      1em;
        top:        0.2em;
        color:    #ccc;
      }

      &.invalid {
        border: 1px solid #f05050;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/CheckInTerms.vue